import { apiBaseUrl } from '../config';
import { request } from '../utils/http';

export const boligmappaPlusSinglePayment = (type, redirectUrl) => {
  const productTypes = {
    month: 'boligmappa-pluss-monthly',
    year: 'boligmappa-pluss-yearly',
  };
  return request({
    method: 'post',
    url: 'propertyowners/user-subscriptions',
    baseURL: apiBaseUrl,
    data: {
      paymentMethod: 'VIPPS',
      subscriptionProductId: productTypes[type],
      signupRedirectUrl: `${redirectUrl}?subscribed=true`,
    },
  })
    .then((response) => [null, response.data])
    .catch((error) => [error, null]);
};

// Todo: implement when page for it is ready
// export const boligmappaPlusCancel = () => request({
//   method: 'delete',
//   url: 'propertyowners/user-subscriptions/85',
//   baseURL: apiBaseUrl,
// })
//   .then((response) => [null, response.data])
//   .catch((error) => [error, null]);
